import React, { useEffect, useState } from 'react';

function ToggleButtons( {name1, name2, onToggle} ) {
  const [activeButton, setActiveButton] = useState(name1);

  const handleClick = (name) => {
    setActiveButton(name);
    onToggle(name); // Trigger the callback with the new active button's name
  };
  useEffect(()=>{
    onToggle(name1);
  },[]);

  return (
    <div className="flex  bg-white border border-gray-300 rounded-lg overflow-hidden shadow-md mx-0 w-full max-w-2xl">
    {[name1, name2].map((name, idx) => {
      const isActive = activeButton === name;
      return (
        <button
          key={name}
          onClick={() => handleClick(name)}
          className={`
            flex-1 py-3 text-center text-sm font-medium transition
            ${isActive ? 'bg-indigo-500 text-white' : 'bg-gray-100 text-gray-700 border border-gray-300'}
          `}
          style={{
            // add a 1px separator except on the last button
            borderRight: idx === 0 ? '1px solid #E5E7EB' : 'none'
          }}
        >
          {name}
        </button>
      );
    })}
  </div>
  );
}

export default ToggleButtons;